/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {CopyPlan} from '../bioplanModels';
// @ts-ignore
import type {CreatePlanFromOrganization} from '../bioplanModels';
// @ts-ignore
import type {EditPlan} from '../bioplanModels';
// @ts-ignore
import type {ExportImport} from '../bioplanModels';
// @ts-ignore
import type {Plan} from '../bioplanModels';
// @ts-ignore
import type {PlanHistory} from '../bioplanModels';
// @ts-ignore
import type {PlanID} from '../bioplanModels';
// @ts-ignore
import type {PlanPolling} from '../bioplanModels';
// @ts-ignore
import type {SyncDraft} from '../bioplanModels';
// @ts-ignore
import type {SyncPlan} from '../bioplanModels';
// @ts-ignore
import type {SyncPlanActionsRequest} from '../bioplanModels';
// @ts-ignore
import type {WritePlan} from '../bioplanModels';
// @ts-ignore
import type {WritePlanUsingProductionHistory} from '../bioplanModels';
/**
 * PlanningPlanApi - axios parameter creator
 * @export
 */
export const PlanningPlanApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new plan by copying an existing plan
     * @param {CopyPlan} copyPlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansCopyPost: async (copyPlan: CopyPlan, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'copyPlan' is not null or undefined
      assertParamExists('plansCopyPost', 'copyPlan', copyPlan);
      const localVarPath = `/plans/copy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(copyPlan, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create plan
     * @param {CreatePlanFromOrganization} createPlanFromOrganization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansFromOrganizationPost: async (
      createPlanFromOrganization: CreatePlanFromOrganization,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createPlanFromOrganization' is not null or undefined
      assertParamExists('plansFromOrganizationPost', 'createPlanFromOrganization', createPlanFromOrganization);
      const localVarPath = `/plans/fromOrganization`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPlanFromOrganization,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get plans. If no query params are sent then plans will be filtered by current user.
     * @param {boolean} [inactive]
     * @param {string} [tenantId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansGet: async (
      inactive?: boolean,
      tenantId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/plans/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (inactive !== undefined) {
        localVarQueryParameter['inactive'] = inactive;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter['tenantId'] = tenantId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Import a plan
     * @param {ExportImport} exportImport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansImportPost: async (exportImport: ExportImport, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'exportImport' is not null or undefined
      assertParamExists('plansImportPost', 'exportImport', exportImport);
      const localVarPath = `/plans/import`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(exportImport, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get inactive plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansInactiveGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/plans/inactive`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete plan by its identifier
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdDelete: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdDelete', 'planId', planId);
      const localVarPath = `/plans/{planId}`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export a plan to file that can be imported
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdExportGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdExportGet', 'planId', planId);
      const localVarPath = `/plans/{planId}/export`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get plan by its identifier.
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdGet', 'planId', planId);
      const localVarPath = `/plans/{planId}`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export a plan to time series file that can be imported
     * @param {string} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {PlansPlanIdHarvestReportGetGroupByEnum} [groupBy]
     * @param {PlansPlanIdHarvestReportGetFileFormatEnum} [fileFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdHarvestReportGet: async (
      planId: string,
      startDate?: string,
      endDate?: string,
      groupBy?: PlansPlanIdHarvestReportGetGroupByEnum,
      fileFormat?: PlansPlanIdHarvestReportGetFileFormatEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdHarvestReportGet', 'planId', planId);
      const localVarPath = `/plans/{planId}/harvestReport`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy;
      }

      if (fileFormat !== undefined) {
        localVarQueryParameter['fileFormat'] = fileFormat;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get plan history
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdHistoryGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdHistoryGet', 'planId', planId);
      const localVarPath = `/plans/{planId}/history`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permanently delete plan by its identifier
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdPermanentDeleteDelete: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdPermanentDeleteDelete', 'planId', planId);
      const localVarPath = `/plans/{planId}/permanentDelete`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Check if plan has been updated
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdPollingGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdPollingGet', 'planId', planId);
      const localVarPath = `/plans/{planId}/polling`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update plan
     * @param {string} planId
     * @param {EditPlan} editPlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdPut: async (
      planId: string,
      editPlan: EditPlan,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdPut', 'planId', planId);
      // verify required parameter 'editPlan' is not null or undefined
      assertParamExists('plansPlanIdPut', 'editPlan', editPlan);
      const localVarPath = `/plans/{planId}`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(editPlan, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Restore archived plan by its ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdRestorePut: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdRestorePut', 'planId', planId);
      const localVarPath = `/plans/{planId}/restore`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {SyncPlanActionsRequest} syncPlanActionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdSyncActionsPost: async (
      planId: string,
      syncPlanActionsRequest: SyncPlanActionsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdSyncActionsPost', 'planId', planId);
      // verify required parameter 'syncPlanActionsRequest' is not null or undefined
      assertParamExists('plansPlanIdSyncActionsPost', 'syncPlanActionsRequest', syncPlanActionsRequest);
      const localVarPath = `/plans/{planId}/syncActions`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        syncPlanActionsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {string} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdSyncDraftGet: async (
      planId: string,
      date?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdSyncDraftGet', 'planId', planId);
      const localVarPath = `/plans/{planId}/syncDraft`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString().substring(0, 10) : date;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export a plan to time series file that can be imported
     * @param {string} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {PlansPlanIdTimeseriesGetColumnsEnum} [columns]
     * @param {PlansPlanIdTimeseriesGetFileFormatEnum} [fileFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdTimeseriesGet: async (
      planId: string,
      startDate?: string,
      endDate?: string,
      columns?: PlansPlanIdTimeseriesGetColumnsEnum,
      fileFormat?: PlansPlanIdTimeseriesGetFileFormatEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('plansPlanIdTimeseriesGet', 'planId', planId);
      const localVarPath = `/plans/{planId}/timeseries`.replace(`{${'planId'}}`, encodeURIComponent(String(planId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (columns) {
        localVarQueryParameter['columns'] = columns;
      }

      if (fileFormat !== undefined) {
        localVarQueryParameter['fileFormat'] = fileFormat;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create plan
     * @param {WritePlan} writePlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPost: async (writePlan: WritePlan, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'writePlan' is not null or undefined
      assertParamExists('plansPost', 'writePlan', writePlan);
      const localVarPath = `/plans/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writePlan, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create plan using tenant production history
     * @param {WritePlanUsingProductionHistory} writePlanUsingProductionHistory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansProductionHistoryPost: async (
      writePlanUsingProductionHistory: WritePlanUsingProductionHistory,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'writePlanUsingProductionHistory' is not null or undefined
      assertParamExists(
        'plansProductionHistoryPost',
        'writePlanUsingProductionHistory',
        writePlanUsingProductionHistory,
      );
      const localVarPath = `/plans/productionHistory`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        writePlanUsingProductionHistory,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningPlanApi - functional programming interface
 * @export
 */
export const PlanningPlanApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningPlanApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new plan by copying an existing plan
     * @param {CopyPlan} copyPlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansCopyPost(
      copyPlan: CopyPlan,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansCopyPost(copyPlan, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansCopyPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create plan
     * @param {CreatePlanFromOrganization} createPlanFromOrganization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansFromOrganizationPost(
      createPlanFromOrganization: CreatePlanFromOrganization,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansFromOrganizationPost(
        createPlanFromOrganization,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansFromOrganizationPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get plans. If no query params are sent then plans will be filtered by current user.
     * @param {boolean} [inactive]
     * @param {string} [tenantId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansGet(
      inactive?: boolean,
      tenantId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Plan>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansGet(inactive, tenantId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Import a plan
     * @param {ExportImport} exportImport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansImportPost(
      exportImport: ExportImport,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansImportPost(exportImport, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansImportPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get inactive plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansInactiveGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanID>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansInactiveGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansInactiveGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete plan by its identifier
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdDelete(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdDelete(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Export a plan to file that can be imported
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdExportGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportImport>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdExportGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdExportGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get plan by its identifier.
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Export a plan to time series file that can be imported
     * @param {string} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {PlansPlanIdHarvestReportGetGroupByEnum} [groupBy]
     * @param {PlansPlanIdHarvestReportGetFileFormatEnum} [fileFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdHarvestReportGet(
      planId: string,
      startDate?: string,
      endDate?: string,
      groupBy?: PlansPlanIdHarvestReportGetGroupByEnum,
      fileFormat?: PlansPlanIdHarvestReportGetFileFormatEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdHarvestReportGet(
        planId,
        startDate,
        endDate,
        groupBy,
        fileFormat,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdHarvestReportGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get plan history
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdHistoryGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanHistory>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdHistoryGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdHistoryGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Permanently delete plan by its identifier
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdPermanentDeleteDelete(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdPermanentDeleteDelete(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdPermanentDeleteDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Check if plan has been updated
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdPollingGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanPolling>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdPollingGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdPollingGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update plan
     * @param {string} planId
     * @param {EditPlan} editPlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdPut(
      planId: string,
      editPlan: EditPlan,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdPut(planId, editPlan, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Restore archived plan by its ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdRestorePut(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdRestorePut(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdRestorePut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {SyncPlanActionsRequest} syncPlanActionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdSyncActionsPost(
      planId: string,
      syncPlanActionsRequest: SyncPlanActionsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncPlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdSyncActionsPost(
        planId,
        syncPlanActionsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdSyncActionsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {string} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdSyncDraftGet(
      planId: string,
      date?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncDraft>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdSyncDraftGet(planId, date, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdSyncDraftGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Export a plan to time series file that can be imported
     * @param {string} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {PlansPlanIdTimeseriesGetColumnsEnum} [columns]
     * @param {PlansPlanIdTimeseriesGetFileFormatEnum} [fileFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPlanIdTimeseriesGet(
      planId: string,
      startDate?: string,
      endDate?: string,
      columns?: PlansPlanIdTimeseriesGetColumnsEnum,
      fileFormat?: PlansPlanIdTimeseriesGetFileFormatEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPlanIdTimeseriesGet(
        planId,
        startDate,
        endDate,
        columns,
        fileFormat,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPlanIdTimeseriesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create plan
     * @param {WritePlan} writePlan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansPost(
      writePlan: WritePlan,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansPost(writePlan, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create plan using tenant production history
     * @param {WritePlanUsingProductionHistory} writePlanUsingProductionHistory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async plansProductionHistoryPost(
      writePlanUsingProductionHistory: WritePlanUsingProductionHistory,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Plan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.plansProductionHistoryPost(
        writePlanUsingProductionHistory,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningPlanApi.plansProductionHistoryPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningPlanApi - factory interface
 * @export
 */
export const PlanningPlanApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningPlanApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new plan by copying an existing plan
     * @param {PlanningPlanApiPlansCopyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansCopyPost(
      requestParameters: PlanningPlanApiPlansCopyPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Plan> {
      return localVarFp.plansCopyPost(requestParameters.copyPlan, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create plan
     * @param {PlanningPlanApiPlansFromOrganizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansFromOrganizationPost(
      requestParameters: PlanningPlanApiPlansFromOrganizationPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Plan> {
      return localVarFp
        .plansFromOrganizationPost(requestParameters.createPlanFromOrganization, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get plans. If no query params are sent then plans will be filtered by current user.
     * @param {PlanningPlanApiPlansGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansGet(
      requestParameters: PlanningPlanApiPlansGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Plan>> {
      return localVarFp
        .plansGet(requestParameters.inactive, requestParameters.tenantId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Import a plan
     * @param {PlanningPlanApiPlansImportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansImportPost(
      requestParameters: PlanningPlanApiPlansImportPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Plan> {
      return localVarFp
        .plansImportPost(requestParameters.exportImport, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get inactive plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansInactiveGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanID>> {
      return localVarFp.plansInactiveGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete plan by its identifier
     * @param {PlanningPlanApiPlansPlanIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdDelete(
      requestParameters: PlanningPlanApiPlansPlanIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .plansPlanIdDelete(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Export a plan to file that can be imported
     * @param {PlanningPlanApiPlansPlanIdExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdExportGet(
      requestParameters: PlanningPlanApiPlansPlanIdExportGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ExportImport> {
      return localVarFp
        .plansPlanIdExportGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get plan by its identifier.
     * @param {PlanningPlanApiPlansPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdGet(
      requestParameters: PlanningPlanApiPlansPlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Plan> {
      return localVarFp.plansPlanIdGet(requestParameters.planId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Export a plan to time series file that can be imported
     * @param {PlanningPlanApiPlansPlanIdHarvestReportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdHarvestReportGet(
      requestParameters: PlanningPlanApiPlansPlanIdHarvestReportGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .plansPlanIdHarvestReportGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.groupBy,
          requestParameters.fileFormat,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get plan history
     * @param {PlanningPlanApiPlansPlanIdHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdHistoryGet(
      requestParameters: PlanningPlanApiPlansPlanIdHistoryGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PlanHistory>> {
      return localVarFp
        .plansPlanIdHistoryGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Permanently delete plan by its identifier
     * @param {PlanningPlanApiPlansPlanIdPermanentDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdPermanentDeleteDelete(
      requestParameters: PlanningPlanApiPlansPlanIdPermanentDeleteDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .plansPlanIdPermanentDeleteDelete(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Check if plan has been updated
     * @param {PlanningPlanApiPlansPlanIdPollingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdPollingGet(
      requestParameters: PlanningPlanApiPlansPlanIdPollingGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PlanPolling> {
      return localVarFp
        .plansPlanIdPollingGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update plan
     * @param {PlanningPlanApiPlansPlanIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdPut(
      requestParameters: PlanningPlanApiPlansPlanIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Plan> {
      return localVarFp
        .plansPlanIdPut(requestParameters.planId, requestParameters.editPlan, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Restore archived plan by its ID
     * @param {PlanningPlanApiPlansPlanIdRestorePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdRestorePut(
      requestParameters: PlanningPlanApiPlansPlanIdRestorePutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Plan> {
      return localVarFp
        .plansPlanIdRestorePut(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlanningPlanApiPlansPlanIdSyncActionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdSyncActionsPost(
      requestParameters: PlanningPlanApiPlansPlanIdSyncActionsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SyncPlan> {
      return localVarFp
        .plansPlanIdSyncActionsPost(requestParameters.planId, requestParameters.syncPlanActionsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlanningPlanApiPlansPlanIdSyncDraftGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdSyncDraftGet(
      requestParameters: PlanningPlanApiPlansPlanIdSyncDraftGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SyncDraft> {
      return localVarFp
        .plansPlanIdSyncDraftGet(requestParameters.planId, requestParameters.date, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Export a plan to time series file that can be imported
     * @param {PlanningPlanApiPlansPlanIdTimeseriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPlanIdTimeseriesGet(
      requestParameters: PlanningPlanApiPlansPlanIdTimeseriesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      return localVarFp
        .plansPlanIdTimeseriesGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.columns,
          requestParameters.fileFormat,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create plan
     * @param {PlanningPlanApiPlansPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansPost(requestParameters: PlanningPlanApiPlansPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Plan> {
      return localVarFp.plansPost(requestParameters.writePlan, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create plan using tenant production history
     * @param {PlanningPlanApiPlansProductionHistoryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    plansProductionHistoryPost(
      requestParameters: PlanningPlanApiPlansProductionHistoryPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Plan> {
      return localVarFp
        .plansProductionHistoryPost(requestParameters.writePlanUsingProductionHistory, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for plansCopyPost operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansCopyPostRequest
 */
export interface PlanningPlanApiPlansCopyPostRequest {
  /**
   *
   * @type {CopyPlan}
   * @memberof PlanningPlanApiPlansCopyPost
   */
  readonly copyPlan: CopyPlan;
}

/**
 * Request parameters for plansFromOrganizationPost operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansFromOrganizationPostRequest
 */
export interface PlanningPlanApiPlansFromOrganizationPostRequest {
  /**
   *
   * @type {CreatePlanFromOrganization}
   * @memberof PlanningPlanApiPlansFromOrganizationPost
   */
  readonly createPlanFromOrganization: CreatePlanFromOrganization;
}

/**
 * Request parameters for plansGet operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansGetRequest
 */
export interface PlanningPlanApiPlansGetRequest {
  /**
   *
   * @type {boolean}
   * @memberof PlanningPlanApiPlansGet
   */
  readonly inactive?: boolean;

  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansGet
   */
  readonly tenantId?: string;
}

/**
 * Request parameters for plansImportPost operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansImportPostRequest
 */
export interface PlanningPlanApiPlansImportPostRequest {
  /**
   *
   * @type {ExportImport}
   * @memberof PlanningPlanApiPlansImportPost
   */
  readonly exportImport: ExportImport;
}

/**
 * Request parameters for plansPlanIdDelete operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdDeleteRequest
 */
export interface PlanningPlanApiPlansPlanIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for plansPlanIdExportGet operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdExportGetRequest
 */
export interface PlanningPlanApiPlansPlanIdExportGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdExportGet
   */
  readonly planId: string;
}

/**
 * Request parameters for plansPlanIdGet operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdGetRequest
 */
export interface PlanningPlanApiPlansPlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for plansPlanIdHarvestReportGet operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdHarvestReportGetRequest
 */
export interface PlanningPlanApiPlansPlanIdHarvestReportGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdHarvestReportGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdHarvestReportGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdHarvestReportGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {'week' | 'month'}
   * @memberof PlanningPlanApiPlansPlanIdHarvestReportGet
   */
  readonly groupBy?: PlansPlanIdHarvestReportGetGroupByEnum;

  /**
   *
   * @type {'excel' | 'csv'}
   * @memberof PlanningPlanApiPlansPlanIdHarvestReportGet
   */
  readonly fileFormat?: PlansPlanIdHarvestReportGetFileFormatEnum;
}

/**
 * Request parameters for plansPlanIdHistoryGet operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdHistoryGetRequest
 */
export interface PlanningPlanApiPlansPlanIdHistoryGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdHistoryGet
   */
  readonly planId: string;
}

/**
 * Request parameters for plansPlanIdPermanentDeleteDelete operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdPermanentDeleteDeleteRequest
 */
export interface PlanningPlanApiPlansPlanIdPermanentDeleteDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdPermanentDeleteDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for plansPlanIdPollingGet operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdPollingGetRequest
 */
export interface PlanningPlanApiPlansPlanIdPollingGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdPollingGet
   */
  readonly planId: string;
}

/**
 * Request parameters for plansPlanIdPut operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdPutRequest
 */
export interface PlanningPlanApiPlansPlanIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdPut
   */
  readonly planId: string;

  /**
   *
   * @type {EditPlan}
   * @memberof PlanningPlanApiPlansPlanIdPut
   */
  readonly editPlan: EditPlan;
}

/**
 * Request parameters for plansPlanIdRestorePut operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdRestorePutRequest
 */
export interface PlanningPlanApiPlansPlanIdRestorePutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdRestorePut
   */
  readonly planId: string;
}

/**
 * Request parameters for plansPlanIdSyncActionsPost operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdSyncActionsPostRequest
 */
export interface PlanningPlanApiPlansPlanIdSyncActionsPostRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdSyncActionsPost
   */
  readonly planId: string;

  /**
   *
   * @type {SyncPlanActionsRequest}
   * @memberof PlanningPlanApiPlansPlanIdSyncActionsPost
   */
  readonly syncPlanActionsRequest: SyncPlanActionsRequest;
}

/**
 * Request parameters for plansPlanIdSyncDraftGet operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdSyncDraftGetRequest
 */
export interface PlanningPlanApiPlansPlanIdSyncDraftGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdSyncDraftGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdSyncDraftGet
   */
  readonly date?: string;
}

/**
 * Request parameters for plansPlanIdTimeseriesGet operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPlanIdTimeseriesGetRequest
 */
export interface PlanningPlanApiPlansPlanIdTimeseriesGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdTimeseriesGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdTimeseriesGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningPlanApiPlansPlanIdTimeseriesGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningPlanApiPlansPlanIdTimeseriesGet
   */
  readonly columns?: PlansPlanIdTimeseriesGetColumnsEnum;

  /**
   *
   * @type {'csv' | 'excel'}
   * @memberof PlanningPlanApiPlansPlanIdTimeseriesGet
   */
  readonly fileFormat?: PlansPlanIdTimeseriesGetFileFormatEnum;
}

/**
 * Request parameters for plansPost operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansPostRequest
 */
export interface PlanningPlanApiPlansPostRequest {
  /**
   *
   * @type {WritePlan}
   * @memberof PlanningPlanApiPlansPost
   */
  readonly writePlan: WritePlan;
}

/**
 * Request parameters for plansProductionHistoryPost operation in PlanningPlanApi.
 * @export
 * @interface PlanningPlanApiPlansProductionHistoryPostRequest
 */
export interface PlanningPlanApiPlansProductionHistoryPostRequest {
  /**
   *
   * @type {WritePlanUsingProductionHistory}
   * @memberof PlanningPlanApiPlansProductionHistoryPost
   */
  readonly writePlanUsingProductionHistory: WritePlanUsingProductionHistory;
}

/**
 * PlanningPlanApi - object-oriented interface
 * @export
 * @class PlanningPlanApi
 * @extends {BaseAPI}
 */
export class PlanningPlanApi extends BaseAPI {
  /**
   *
   * @summary Create a new plan by copying an existing plan
   * @param {PlanningPlanApiPlansCopyPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansCopyPost(requestParameters: PlanningPlanApiPlansCopyPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningPlanApiFp(this.configuration)
      .plansCopyPost(requestParameters.copyPlan, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create plan
   * @param {PlanningPlanApiPlansFromOrganizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansFromOrganizationPost(
    requestParameters: PlanningPlanApiPlansFromOrganizationPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansFromOrganizationPost(requestParameters.createPlanFromOrganization, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get plans. If no query params are sent then plans will be filtered by current user.
   * @param {PlanningPlanApiPlansGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansGet(requestParameters: PlanningPlanApiPlansGetRequest = {}, options?: RawAxiosRequestConfig) {
    return PlanningPlanApiFp(this.configuration)
      .plansGet(requestParameters.inactive, requestParameters.tenantId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Import a plan
   * @param {PlanningPlanApiPlansImportPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansImportPost(requestParameters: PlanningPlanApiPlansImportPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningPlanApiFp(this.configuration)
      .plansImportPost(requestParameters.exportImport, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get inactive plans
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansInactiveGet(options?: RawAxiosRequestConfig) {
    return PlanningPlanApiFp(this.configuration)
      .plansInactiveGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete plan by its identifier
   * @param {PlanningPlanApiPlansPlanIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdDelete(
    requestParameters: PlanningPlanApiPlansPlanIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdDelete(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Export a plan to file that can be imported
   * @param {PlanningPlanApiPlansPlanIdExportGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdExportGet(
    requestParameters: PlanningPlanApiPlansPlanIdExportGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdExportGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get plan by its identifier.
   * @param {PlanningPlanApiPlansPlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdGet(requestParameters: PlanningPlanApiPlansPlanIdGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Export a plan to time series file that can be imported
   * @param {PlanningPlanApiPlansPlanIdHarvestReportGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdHarvestReportGet(
    requestParameters: PlanningPlanApiPlansPlanIdHarvestReportGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdHarvestReportGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.groupBy,
        requestParameters.fileFormat,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get plan history
   * @param {PlanningPlanApiPlansPlanIdHistoryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdHistoryGet(
    requestParameters: PlanningPlanApiPlansPlanIdHistoryGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdHistoryGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Permanently delete plan by its identifier
   * @param {PlanningPlanApiPlansPlanIdPermanentDeleteDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdPermanentDeleteDelete(
    requestParameters: PlanningPlanApiPlansPlanIdPermanentDeleteDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdPermanentDeleteDelete(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Check if plan has been updated
   * @param {PlanningPlanApiPlansPlanIdPollingGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdPollingGet(
    requestParameters: PlanningPlanApiPlansPlanIdPollingGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdPollingGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update plan
   * @param {PlanningPlanApiPlansPlanIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdPut(requestParameters: PlanningPlanApiPlansPlanIdPutRequest, options?: RawAxiosRequestConfig) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdPut(requestParameters.planId, requestParameters.editPlan, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Restore archived plan by its ID
   * @param {PlanningPlanApiPlansPlanIdRestorePutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdRestorePut(
    requestParameters: PlanningPlanApiPlansPlanIdRestorePutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdRestorePut(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlanningPlanApiPlansPlanIdSyncActionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdSyncActionsPost(
    requestParameters: PlanningPlanApiPlansPlanIdSyncActionsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdSyncActionsPost(requestParameters.planId, requestParameters.syncPlanActionsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlanningPlanApiPlansPlanIdSyncDraftGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdSyncDraftGet(
    requestParameters: PlanningPlanApiPlansPlanIdSyncDraftGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdSyncDraftGet(requestParameters.planId, requestParameters.date, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Export a plan to time series file that can be imported
   * @param {PlanningPlanApiPlansPlanIdTimeseriesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPlanIdTimeseriesGet(
    requestParameters: PlanningPlanApiPlansPlanIdTimeseriesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansPlanIdTimeseriesGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.columns,
        requestParameters.fileFormat,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create plan
   * @param {PlanningPlanApiPlansPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansPost(requestParameters: PlanningPlanApiPlansPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningPlanApiFp(this.configuration)
      .plansPost(requestParameters.writePlan, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create plan using tenant production history
   * @param {PlanningPlanApiPlansProductionHistoryPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningPlanApi
   */
  public plansProductionHistoryPost(
    requestParameters: PlanningPlanApiPlansProductionHistoryPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningPlanApiFp(this.configuration)
      .plansProductionHistoryPost(requestParameters.writePlanUsingProductionHistory, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const PlansPlanIdHarvestReportGetGroupByEnum = {
  Week: 'week',
  Month: 'month',
} as const;
export type PlansPlanIdHarvestReportGetGroupByEnum =
  (typeof PlansPlanIdHarvestReportGetGroupByEnum)[keyof typeof PlansPlanIdHarvestReportGetGroupByEnum];
/**
 * @export
 */
export const PlansPlanIdHarvestReportGetFileFormatEnum = {
  Excel: 'excel',
  Csv: 'csv',
} as const;
export type PlansPlanIdHarvestReportGetFileFormatEnum =
  (typeof PlansPlanIdHarvestReportGetFileFormatEnum)[keyof typeof PlansPlanIdHarvestReportGetFileFormatEnum];
/**
 * @export
 */
export const PlansPlanIdTimeseriesGetColumnsEnum = {} as const;
export type PlansPlanIdTimeseriesGetColumnsEnum =
  (typeof PlansPlanIdTimeseriesGetColumnsEnum)[keyof typeof PlansPlanIdTimeseriesGetColumnsEnum];
/**
 * @export
 */
export const PlansPlanIdTimeseriesGetFileFormatEnum = {
  Csv: 'csv',
  Excel: 'excel',
} as const;
export type PlansPlanIdTimeseriesGetFileFormatEnum =
  (typeof PlansPlanIdTimeseriesGetFileFormatEnum)[keyof typeof PlansPlanIdTimeseriesGetFileFormatEnum];
